import { commonNewClassnames } from '@common';
import { routerPaths as adminRouterPaths } from './admin/tool';
import { routerPaths as studentRouterPaths } from './student/tool';
import { routerPaths as reportRouterPaths } from './admin/reporting/tool';

const prefix = 'cis';
export const newClassnames = (name) => commonNewClassnames(prefix + '-' + name);

export const routerPaths = {
    home: '/',
    cisHome: '/cis',
    oauth: '/oauth',
    admin: '/admin',
    student: '/student',
    changePassword: `/changepassword`
};

export const homeRouterPaths = {
    adminHome: "/admin",
    adminPrefixHome: "/cis/admin",
    studentHome: "/student",
    studentPrefixHome: "/cis/student",
};

export const studentAuthRouterPaths = [
    routerPaths.student,
    homeRouterPaths.studentPrefixHome,
    studentRouterPaths.home,
    studentRouterPaths.privacyStatement,
    studentRouterPaths.termsOfUse,
    studentRouterPaths.FAQ
];

export const adminAuthRouterPaths = [
    routerPaths.admin,
    homeRouterPaths.adminPrefixHome,
    adminRouterPaths.emailTemplate,
    adminRouterPaths.reporting,
    adminRouterPaths.studentManagement,
    adminRouterPaths.groupManagement,
    adminRouterPaths.groupDetails,
    adminRouterPaths.FAQ,
    reportRouterPaths.applicationUsage,
    reportRouterPaths.suspiciousActivity,
    reportRouterPaths.auditlogs,
    reportRouterPaths.signInLogs,
    reportRouterPaths.staffAcessReview,
];